
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

const ListingCardSkeleton: React.FC = () => {
  return (
    <Card className="h-full">
      <div className="aspect-[3/2] overflow-hidden rounded-t-lg">
        <Skeleton className="w-full h-full" />
      </div>
      <CardContent className="p-4 space-y-3">
        <div className="flex justify-between items-start mb-2">
          <Skeleton className="h-6 w-16 rounded-full" />
          <Skeleton className="h-6 w-20" />
        </div>
        
        <Skeleton className="h-5 w-full" />
        <Skeleton className="h-5 w-3/4" />
        
        <div className="flex items-center mb-3">
          <Skeleton className="w-4 h-4 mr-2" />
          <Skeleton className="h-4 w-24" />
        </div>
        
        <Skeleton className="h-4 w-32" />
        
        <div className="pt-2 border-t border-gray-100">
          <div className="grid grid-cols-2 gap-6 text-sm">
            <div className="space-y-2">
              <div className="flex justify-between">
                <Skeleton className="h-4 w-6" />
                <Skeleton className="h-4 w-8" />
              </div>
              <div className="flex justify-between">
                <Skeleton className="h-4 w-6" />
                <Skeleton className="h-4 w-8" />
              </div>
            </div>
            <div className="space-y-2">
              <div className="flex justify-between">
                <Skeleton className="h-4 w-6" />
                <Skeleton className="h-4 w-8" />
              </div>
              <div className="flex justify-between">
                <Skeleton className="h-4 w-8" />
                <Skeleton className="h-4 w-8" />
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ListingCardSkeleton;
